import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { CreateDocSubsetRequestDto } from '../../../../backend/src/case/doc-subset/dto/create-doc-subset.request.dto';
import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

export const useCreateDocSubset = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ caseId, body }: { caseId: string; body: CreateDocSubsetRequestDto }) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.POST,
        data: {
          ...body,
        },
      });

      const res = await fetch(`${APIBaseChronos}/api/case/${caseId}/doc-subset`, fetchConfig);

      res.statusText;
      if (!res.ok) {
        throw new Error(`Failed to create doc subset: ${res.statusText}`);
      }

      return res.json();
    },
    onSuccess: (data) => {
      toast.success('Document subset created successfully');
      queryClient.invalidateQueries({ queryKey: [QueryEntity.DocSubsets, { caseId: data.caseId }] });
    },
    onError: (error) => {
      console.error('Create doc subset error');
      toast.error('Failed to create document subset. Please try again.');
    },
  });
};
